import {
  ClientPerspective,
  createClient,
  type ClientConfig,
} from "@sanity/client";
import { formatDate } from "@utils/date";

const currentDate = formatDate(new Date());

const perspective =
  (import.meta.env.VITE_SANITY_PERSPECTIVE as ClientPerspective) ?? "published";
const useCdn = perspective === "published";
const token = import.meta.env.VITE_SANITY_TOKEN ?? "";

const config: ClientConfig = {
  apiVersion: currentDate,
  projectId: import.meta.env.VITE_SANITY_PROJECTID,
  dataset: import.meta.env.VITE_SANITY_DATASET,
  token,
  useCdn,
  perspective,
};

export const client = createClient(config);
